import { Space, Input, Button } from 'antd';
import { useState, ChangeEvent, useEffect } from 'react';
import {
  RolesDrawerType,
  IRBACUserGroup,
  IRBACRole,
  IRBACUserGroupRole,
  // IAPIStudioMemberItem,
  RbacRoleObjectKey,
  IServicePermissions,
  RbacRoleType,
} from '../../../../../model/rbac';
import {
  IAPIGameItem,
  IAPIStudioMemberHasPermissionItem,
  IAPIStudioInfo,
  IMessageItem,
  MessageSubType,
  IAuditItem,
} from '../../../../../model/api-modules';
import styles from './index.module.scss';
import getFormatMessage from '../../../../../locales/get-format-message';
import { GroupsDrawer } from './groups-drawer';
import { RolesDrawer } from '../roles/roles-drawer';
import classNames from 'classnames';
import { SvgIcon } from '../../../../../components/svg-icon';
import { SvgIconName } from '../../../../../components/svg-icon/model';
import inputSearch from '../../../../../assets/img/input-search.png';
import { CommonOperateModal } from '../../common-modal';
import { getMessageList, messageRed } from '../../../../../api';
import { deleteUserGroups } from '../../../../../api/rbac';
import {
  messageError,
  messageSuccess,
} from '../../../../../components/message';
import { PermissionCheck } from '../../../../component/permission-check';
import { MessageModal } from '../../../../component/message-center/message-modal';
import { AutoTable } from '../../../../../components/auto-table';
import { IListItem } from '../../../../../components/auto-table/model';
// import { AutoTooltip } from '../../../../../components/auto-tooltip';
import { CustomPopover } from '../../../../../components/custom-popover';
import { auditReadLog, auditWriteLog } from '../../../../lib/aduit-log';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../../../store/reducers';

interface IProps {
  readonly loading: boolean;
  readonly groupsList: ReadonlyArray<IRBACUserGroup>;
  readonly rolesList: ReadonlyArray<IRBACRole>;
  readonly studioId: string;
  readonly onUpdate: () => void;
  readonly gameList: ReadonlyArray<IAPIGameItem>;
  readonly allEnvList: any;
  readonly memberList: ReadonlyArray<IAPIStudioMemberHasPermissionItem>;
  readonly studioInfo: IAPIStudioInfo;
  readonly permissionsList: IServicePermissions | null;
  readonly onRoleUpdate: () => void;
  readonly isFirstLoad: React.MutableRefObject<boolean>;
}
export const GroupsComponent = (props: IProps) => {
  const [editType, setEditType] = useState<RolesDrawerType | null>(null);
  const [showRoleDrawer, setShowRoleDrawer] = useState<boolean>(false);
  const [currentRecord, setCurrentRecord] = useState<IRBACUserGroup | null>(
    null
  );
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [filterTable, setFilterTable] = useState<ReadonlyArray<IRBACUserGroup>>(
    []
  );
  const [messageRes, setMessageRes] = useState<any>();
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);
  // const userId = userInfo?.UserID;
  const [unreadMessageList, setUnreadMessageList] =
    useState<IMessageItem | null>(null);
  const [memberStatus, setMemberStatus] = useState<number | undefined>();
  const [isCreate, setIsCreate] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const urlParams = new URLSearchParams(window.location.search);
  const action = urlParams.get('action');

  useEffect(() => {
    auditReadLog(IAuditItem.ViewOrganizationGroups);
    if (action === 'add' && props.isFirstLoad.current) {
      props.isFirstLoad.current = false;
      setEditType(RolesDrawerType.Create);
    }
  }, []);

  useEffect(() => {
    setFilterTable(props.groupsList);
  }, [props.groupsList]);

  const onDrawerClose = () => {
    setEditType(null);
    setCurrentRecord(null);
  };

  useEffect(() => {
    // console.log('memberStatus父类获取222，messageRes：,isCreate', memberStatus,messageRes,isCreate);
    if (messageRes && memberStatus) {
      const isChanged = messageRes?.data?.diffResult.isChanged;
      const messageResult = messageRes?.data?.messageResult;
      if (messageResult && isChanged) {
        const isScopedChanged = messageResult.roleOrScope === true;
        const isRemoved = messageResult.remove;
        const isAdd = messageResult.add;
        if (memberStatus === 0 && isScopedChanged) {
          showDialog([
            MessageSubType.PermissionChange,
            MessageSubType.PermissionScopeChange,
          ]);
        } else if (memberStatus === 1 && isAdd) {
          showDialog([MessageSubType.PermissionUserGroupJoin]);
        } else if (memberStatus === 2 && isRemoved) {
          showDialog([MessageSubType.PermissionUserGroupRemove]);
        }
      } else if (memberStatus === 1 && isCreate) {
        showDialog([MessageSubType.PermissionUserGroupJoin]);
      }
    }
  }, [memberStatus, messageRes, isCreate]);
  const handleMessageResult = (res: any, isCreate?: boolean) => {
    setIsCreate(isCreate ? isCreate : false);
    setMessageRes(res);
  };

  const renderDrawer = () => {
    if (editType) {
      return (
        <GroupsDrawer
          onClose={onDrawerClose}
          type={editType}
          currentRecord={currentRecord}
          studioId={props.studioId}
          onUpdate={props.onUpdate}
          rolesList={props.rolesList}
          gameList={props.gameList}
          allEnvList={props.allEnvList}
          memberList={props.memberList}
          studioInfo={props.studioInfo}
          setShowRoleDrawer={setShowRoleDrawer}
          handleMessageResult={handleMessageResult}
          getMemberStatus={setMemberStatus}
          setEditType={setEditType}
          groupsList={props.groupsList}
        />
      );
    }
    return null;
  };

  const renderRoleDrawer = () => {
    if (showRoleDrawer) {
      return (
        <RolesDrawer
          onClose={() => setShowRoleDrawer(false)}
          type={RolesDrawerType.Create}
          currentRecord={null}
          studioId={props.studioId}
          onUpdate={props.onRoleUpdate}
          permissionsList={props.permissionsList}
          setEditType={setEditType} // 查看需要角色的setEditType 但是这里的新增 传个用户组的 不影响
        />
      );
    }
    return null;
  };

  const getEditDisabledDesc = (record: IRBACUserGroup) => {
    if (record?.groupName === 'Editor Group') {
      return getFormatMessage('groups_editor_desc');
    }
    if (record?.groupName === 'Viewer Group') {
      return getFormatMessage('groups_viewer_desc');
    }
    if (record?.groupName === 'Admin Group') {
      return getFormatMessage('groups_admin_desc');
    }
    return record?.desc || '--';
  };

  const COLUMNS = [
    {
      name: getFormatMessage('group_name'),
      key: 'groupId',
      tableExtension: {
        renderRow(_key: any, _value: number) {
          const groupItem =
            props.groupsList.filter((item) => item.groupId === _value) || [];
          if (groupItem.length !== 0) {
            return (
              <div style={{ minWidth: '120px' }}>
                <span
                  style={{ cursor: 'pointer', color: '#5764F1' }}
                  onClick={() => {
                    setEditType(RolesDrawerType.View);
                    auditReadLog(IAuditItem.ViewOrganizationGroup);
                    setCurrentRecord(groupItem[0]);
                  }}
                >
                  {groupItem[0].groupName}
                </span>
                {(groupItem[0].groupName === 'Admin Group' ||
                  groupItem[0].groupName === 'Editor Group' ||
                  groupItem[0].groupName === 'Viewer Group') && (
                  <span className={styles.systemIcon}>
                    {getFormatMessage('access_right_system_group')}
                  </span>
                )}
              </div>
            );
          }
          return '';
        },
      },
    },
    {
      name: getFormatMessage('description'),
      key: 'desc',
      tableExtension: {
        width: 500,
        renderRow(_key: any, _value: string, row: IListItem) {
          const record = row as IRBACUserGroup;
          return (
            <CustomPopover
              content={getEditDisabledDesc(record)}
              placement="bottomLeft"
            >
              <div className={styles.descItemGroup}>
                {getEditDisabledDesc(record)}
              </div>
            </CustomPopover>
          );
        },
      },
    },
    {
      name: getFormatMessage('member'),
      key: 'members',
      tableExtension: {
        renderRow(_key: any, _value: string[]) {
          return <span>{_value ? _value.length : 0}</span>;
        },
      },
    },
    {
      name: getFormatMessage('view_show_role'),
      key: 'roles',
      tableExtension: {
        renderRow(_key: any, _value: IRBACUserGroupRole[]) {
          return <span>{_value ? _value.length : 0}</span>;
        },
      },
    },
    {
      name: getFormatMessage('operate'),
      key: 'action',
      width: 150,
      tableExtension: {
        renderRow(_key: any, _value: any, row: IListItem) {
          const record = row as IRBACUserGroup;
          return renderDefaultOperate(record);
        },
      },
    },
  ];

  const renderDefaultOperate = (record: IRBACUserGroup): React.ReactNode => {
    return (
      <Space size="middle" className={classNames('operate-btn')}>
        <div className="webkit-box flex-left">
          <PermissionCheck
            customCheck={(perms) => {
              const ownerRole = props.rolesList.find(
                (role) => role.type === RbacRoleType.Owner
              );
              const ownerList = ownerRole?.userList || [];
              if (record.groupName === 'Admin Group') {
                return [...record.members, ...ownerList].includes(
                  userInfo?.UserID || ''
                );
              }
              return perms.includes(RbacRoleObjectKey.UserGroupCreate);
            }}
            tipsPlacement="bottomLeft"
          >
            <a
              style={{ marginRight: '10px' }}
              onClick={() => {
                setEditType(RolesDrawerType.Edit);
                setCurrentRecord(record);
              }}
            >
              {getFormatMessage('edit')}
            </a>
          </PermissionCheck>
          {record.groupName !== 'Editor Group' &&
            record.groupName !== 'Viewer Group' &&
            record.groupName !== 'Admin Group' && (
              <PermissionCheck
                permissionKey={RbacRoleObjectKey.UserGroupDelete}
                tipsPlacement="bottomLeft"
                otherTips={
                  record.members.length !== 0
                    ? getFormatMessage('cannot_delete_group_desc_tips')
                    : ''
                }
              >
                {record.members.length !== 0 ? (
                  <a
                    style={{
                      color: '#F54E4E',
                      opacity: 0.3,
                      cursor: 'not-allowed',
                      marginLeft: '10px',
                    }}
                  >
                    {getFormatMessage('delete')}
                  </a>
                ) : (
                  <a
                    style={{ color: '#F54E4E', marginLeft: '10px' }}
                    onClick={() => {
                      setCurrentRecord(record);
                      setShowDeleteModal(true);
                    }}
                  >
                    {getFormatMessage('delete')}
                  </a>
                )}
              </PermissionCheck>
            )}
        </div>
      </Space>
    );
  };

  const renderDeleteModal = () => {
    if (showDeleteModal) {
      return (
        <CommonOperateModal
          okText={getFormatMessage('confirm')}
          okButtonProps={{
            danger: true,
          }}
          className="delete-modal"
          onClose={() => {
            onDeleteCancel();
          }}
          onOk={onDeleteOk}
          title={getFormatMessage('delete_group')}
          context={
            <>
              <div className="webkit-box flex-start">
                {getFormatMessage('delete_group_desc')}
              </div>
            </>
          }
        />
      );
    }
    return null;
  };

  const onDeleteCancel = () => {
    setCurrentRecord(null);
    setShowDeleteModal(false);
  };

  const onDeleteOk = async () => {
    if (currentRecord?.groupId) {
      const body = {
        studioID: props.studioId,
      };
      const res = await deleteUserGroups(currentRecord.groupId, body);
      auditWriteLog(IAuditItem.DeleteOrganizationGroup, {
        detail: {
          groupID: currentRecord.groupId,
          studioID: props.studioId,
        },
      });
      if (res) {
        messageSuccess(
          getFormatMessage('studio_setting_delete_success', {
            params: {
              studioName: currentRecord.groupName,
            },
          })
        );
        props.onUpdate();
        onDeleteCancel();
        return true;
      }
    }
    onDeleteCancel();
    messageError(getFormatMessage('delete_studio_failed'));
    return false;
  };

  const onSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (value) {
      const reg = new RegExp(value, 'i');
      const arr: IRBACUserGroup[] = [];
      props.groupsList.forEach((item) => {
        if (item.groupName && reg.test(item.groupName)) {
          arr.push(item);
        }
      });
      setFilterTable(arr);
    } else {
      setFilterTable(props.groupsList.slice());
    }
  };
  const onOk = async () => {
    if (unreadMessageList) {
      setUnreadMessageList(null);
      await messageRed(unreadMessageList.id); // 设置为已读
      console.log('刷新页面！！！！');
      window.location.reload(); // 刷新页面
    }
    return true;
  };

  const showDialog = (messageSubTypes: number[]) => {
    const getList = async () => {
      const res = await getMessageList();
      const msgList = res?.list || [];
      const noReadList: IMessageItem[] = [];
      msgList?.forEach((item) => {
        if (!item.ReadInfo) {
          noReadList.push(item);
        }
      });

      const noReadList1: IMessageItem[] = noReadList?.filter((item) =>
        messageSubTypes.includes(item.SubType)
      );
      if (noReadList1.length > 0) {
        setUnreadMessageList(noReadList1[0]);
      }
    };
    getList();
  };

  const currentFilterTable: IRBACUserGroup[] = Object.assign([], filterTable);
  currentFilterTable.length > 1 &&
    currentFilterTable.sort((pre, next) => {
      let sortPre = 0;
      let sortNext = 0;
      if (pre.groupName === 'Admin Group') {
        sortPre = 3;
      } else if (pre.groupName === 'Editor Group') {
        sortPre = 2;
      } else if (pre.groupName === 'Viewer Group') {
        sortPre = 1;
      }
      if (next.groupName === 'Admin Group') {
        sortNext = 3;
      } else if (next.groupName === 'Editor Group') {
        sortNext = 2;
      } else if (next.groupName === 'Viewer Group') {
        sortNext = 1;
      }
      return sortNext - sortPre;
    });

  return (
    <Space direction="vertical" style={{ width: '100%' }} size={0}>
      <div
        className={classNames(
          'webkit-box flex-justify-space-between',
          styles.membersTitle
        )}
      >
        <div className={styles.titleLeft}>
          <PermissionCheck permissionKey={RbacRoleObjectKey.UserGroupCreate}>
            <Button
              onClick={() => setEditType(RolesDrawerType.Create)}
              className="gc-btn gc-btn-primary"
              icon={
                <SvgIcon
                  className="in-game-ant-icon"
                  icon={SvgIconName.InviteAddIcon}
                />
              }
            >
              {getFormatMessage('add_new_group')}
            </Button>
          </PermissionCheck>
        </div>
        <div className="webkit-box flex-center">
          <Input
            placeholder={getFormatMessage('search_group')}
            className="search-input"
            prefix={
              <img
                src={inputSearch}
                className={classNames('icon', styles.inputSearch)}
              />
            }
            onChange={onSearch}
            allowClear
            spellCheck="false"
          />
        </div>
      </div>
      <AutoTable
        // rowKey={(record) => record.groupId}
        list={currentFilterTable}
        configFields={COLUMNS}
        className={styles.groupTable}
        loading={props.loading}
        tableExtension={{
          rowKey: 'groupId',
          pagination: {
            current: currentPage,
            total: currentFilterTable.length,
            pageSize,
            showTotal: (total) => {
              return getFormatMessage('total_items', {
                params: {
                  total,
                },
              });
            },
          },
          onChange: (changeInfo) => {
            if (!changeInfo) {
              return;
            }
            setCurrentPage(changeInfo.current);
            setPageSize(changeInfo.pageSize || 10);
          },
        }}
      />
      {renderDrawer()}
      {renderRoleDrawer()}
      {renderDeleteModal()}
      {unreadMessageList && (
        <MessageModal
          message={unreadMessageList}
          onOk={onOk}
          onCloseFail={onOk}
          isClosed={false}
        />
      )}
    </Space>
  );
};
